// extracted by mini-css-extract-plugin
export default {"order":"Order_order__7L9xH","caption":"Order_caption__f3Rfk","table":"Order_table__PhvJu"};